<template>
  <load-content :loading="loading">
    <div>
      <h3>Assign articles to group</h3>
      <h5>if you want to create a new group, just type the name and press enter</h5>
      <div class="form form--sidepanel">
        <div>
          <div class="form-group">
            <label for="group_id">Group</label>
            <input-select
              ref="group_id"
              name="group_id"
              :options="groups"
              :allowEmpty="false"
              :preselectFirst="true"
              :onChange="onInputChange"
              :searchable="true"
              placeholder="Select a group"
              :taggable="true"
              :onTag="onTag"
              tagPlaceholder="Press enter to create a new group"
              :selectedValue="value"
            />
          </div>

          <div class="form-group">
            <button type="submit" class="btn btn-carma" @click="onSubmitForm" :disabled="value == null">Assign</button>
          </div>
        </div>
      </div>
    </div>      
  </load-content>
</template>

<script>
import LoadContent from "../../components/load-content";
import InputSelect from '../form-components/input-select';

export default {
  props: {
    articles: Array,
    groups: Array,
    onChange: Function,
    onSubmit: Function,
    onSubmitTag: Function,
    loading: Boolean
  },

  components: {
    InputSelect,
    LoadContent
  },

  data: function() {
    return  {
      value: null,
      inputKey: null
    }
  },

  methods: {
    onInputChange: function(value) {
      this.value = value;
    },

    onTag: function(option) {
      this.value = option.value;
      this.onSubmitTag(this.value).then(group => {
        this.onInputChange(group.id);
      });
    },

    onSubmitForm: function() {
      const { articles, value } = this;
      this.onSubmit(articles, value);
    }
  }
}
</script>

<style lang="scss">
  @import "../../styles/components/form";
</style>